import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"
import { initiatePayment } from "../../../../app/store/slices/ticket/ticketBuying"
import { errorToast } from "../../../../utils/toasts/toasts"

export default function useCheckout() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { orderSummary } = useSelector((state) => state.ticketBuying);
    const eventData = useSelector((state) => state.event?.eventData);

    const [showTaxBreakup, setShowTaxBreakup] = useState(false)
    const [phonepeUrl, setPhonepeUrl] = useState(null)
    const [loading, setLoading] = useState(false)
    const [openIframe, setOpenIFrame] = useState(false)

    const [openModal, setOpenModal] = useState(false);
    const [modalVariant, setModalVariant] = useState("eventDrafted"); // "eventCancelled" | "eventDrafted"


    /**
     * TODO: Tell backend to make change in api to add passXheader and eventId
     * @async
     * @function initiatePaymentProcess
     * @description Initiates the payment process by dispatching the initiatePayment action.
     * @throws Will throw an error if the payment initiation fails, with specific handling for event cancellation and drafting scenarios.
     * Steps:
     * 1. Set loading state to true.
     * 2. Dispatch initiatePayment action with booking ID, event ID, and continued booking header.
     * 3. On success, set the PhonePe URL and open the payment iframe.
     * 4. Remove "continuedBooking" from localStorage.
     * 5. On failure, handle specific error codes and messages to show appropriate modals or error toasts.
     * 6. Finally, set loading state to false.
     */
    async function initiatePaymentProcess() {
        try {
            setLoading(true)
            const response = await dispatch(initiatePayment({
                booking_id: 3,
                passXheader: Boolean(localStorage.getItem("continuedBooking") === "true"),
                eventId: eventData?.eventId
            })).unwrap();

            setPhonepeUrl(response?.redirectUrl);
            // setPhonepeUrl('https://mercury-uat.phonepe.com/transact/simulator?token=9E7mYEWviFlagB06K1QIPhTv3AoWeTz3JNhUScECR0')
            setOpenIFrame(true);

            localStorage.removeItem("continuedBooking");

            // console.log("Response -> ", response)
        } catch (error) {
            // Handle specific error scenarios
            if (error?.code === 400) {
                // Check if event is cancelled or drafted

                if (error?.message === 'cancelled') {
                    setModalVariant('eventCancelled');
                    setOpenModal(true);
                } else if (error?.message === 'drafted') {
                    setModalVariant('eventDrafted');
                    setOpenModal(true);
                } else {
                    errorToast(error?.statusText || "Bad Request");
                }

            } else if (error?.code === 404) {
                errorToast(error?.statusText || "Resource not found");
            } else if (error?.code === 500) {
                errorToast(error?.statusText || "Server error occurred");
            } else {
                errorToast(error?.statusText || "An unexpected error occurred.");
            }
        } finally {
            setLoading(false)
        }
    }


    function goToEventPage() {
        setOpenModal(false);
        navigate(`/events`);
    }

    function onModalContinue() {
        localStorage.setItem("continuedBooking", "true");
        initiatePaymentProcess();
    }

    return {
        orderSummary,
        showTaxBreakup,
        setShowTaxBreakup,
        phonepeUrl,
        loading,
        openIframe,
        setOpenIFrame,
        initiatePaymentProcess,
        openModal,
        setOpenModal,
        modalVariant,
        goToEventPage,
        onModalContinue
    }
}